import React, { useState, useEffect } from "react";
import { IoCaretForward, IoPause } from "react-icons/io5";
import { useAudio } from "../../hooks/useAudio";
import ding from "../../assets/sounds/ding.mp3";

import styles from "./timer.module.css";

export default function Timer({ timer, color = "#BD2C52" }) {
  const [seconds, setSeconds] = useState(timer);
  const [isActive, setIsActive] = useState(false);
  const { toggle } = useAudio(ding);

  const toggleTimer = () => {
    setIsActive(!isActive);
  };

  useEffect(() => {
    setSeconds(timer); // Atualiza os segundos quando o `timer` é alterado
  }, [timer]);

  const reset = () => {
    setSeconds(timer);
    setIsActive(false);
  };

  const playSound = () => {
    // TODO
    toggle();
  };

  const formatTime = (time) => {
    const getSeconds = `0${time % 60}`.slice(-2);
    const minutes = Math.floor(time / 60);
    const getMinutes = `0${minutes % 60}`.slice(-2);

    return `${getMinutes} : ${getSeconds}`;
  };

  useEffect(() => {
    let interval = 0;

    if (isActive) {
      interval = setInterval(() => {
        setSeconds((prevSeconds) => {
          if (prevSeconds > 1) {
            return prevSeconds - 1;
          } else {
            clearInterval(interval); // Limpa o intervalo quando o tempo acaba
            playSound();
            return 0;
          }
        });
      }, 1000);
    } else if (!isActive && interval) {
      clearInterval(interval);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isActive]);

  return (
    <div className={styles.timer}>
      <button
        className={styles.actionButton}
        type="button"
        onClick={toggleTimer}
      >
        {isActive ? (
          <IoPause size={28} color={color} />
        ) : (
          <IoCaretForward size={28} color={color} />
        )}
      </button>
      <button
        className={styles.display}
        style={{ color }}
        type="button"
        onClick={reset}
      >
        {formatTime(seconds)}
      </button>
    </div>
  );
}
